import { useMutation } from '@apollo/client';
import { useMemo } from 'react';
import { graphql } from '../gql';

export const UPSERT_BROKER_AGENTSYNC = graphql(`
  mutation upsertPersonFromNpn($personNpn: String!) {
    upsertPersonFromNpn(personNpn: $personNpn) {
      uuid
    }
  }
`);
export function useUpsertBrokerAgentSync() {
  const [upsertBroker, { loading, error, data }] = useMutation(
    UPSERT_BROKER_AGENTSYNC,
    {
      fetchPolicy: 'network-only',
    }
  );

  const broker = useMemo(() => {
    if (!data || !data.upsertPersonFromNpn) return null;
    return { uuid: data.upsertPersonFromNpn.uuid };
  }, [data]);

  return {
    error,
    loading,
    data,
    upsertBroker,
    broker,
  };
}
